// src/api/paramsApi.js
import {$authHost, $host} from "./index"; // Импортируем экземпляры axios из главного index.js

// Bedroom
export const createBedroom = async (bedroom) => {
    try {
        const {data} = await $authHost.post('api/bedroom', bedroom)
        return data
    } catch (e) {
        alert(e.response?.data?.message); // Добавлена обработка ошибки
    }
}
export const fetchBedroom = async () => {
    try {
        const {data} = await $host.get('api/bedroom')
        return data
    } catch (e) {
        alert(e.response?.data?.message); // Добавлена обработка ошибки
    }
}

// Floor
export const createFloor = async (floor) => {
    try {
        const {data} = await $authHost.post('api/floor', floor)
        return data
    } catch (e) {
        alert(e.response?.data?.message); // Добавлена обработка ошибки
    }
}
export const fetchFloor = async () => {
    try {
        const {data} = await $host.get('api/floor')
        return data
    } catch (e) {
        alert(e.response?.data?.message); // Добавлена обработка ошибки
    }
}

// Area
export const fetchArea = async () => {
    try {
        const {data} = await $host.get('api/area')
        return data
    } catch (e) {
        alert(e.response?.data?.message); // Добавлена обработка ошибки
    }
}
export const createArea = async (area) => {
    try {
        const {data} = await $authHost.post('api/area', area)
        return data
    } catch (e) {
        alert(e.response?.data?.message); // Добавлена обработка ошибки
    }
}

// Parking
export const fetchParking = async () => {
    try {
        const {data} = await $host.get('api/parking')
        return data
    } catch (e) {
        alert(e.response?.data?.message); // Добавлена обработка ошибки
    }
}
export const createParking = async (parking) => {
    try {
        const {data} = await $authHost.post('api/parking', parking)
        return data
    } catch (e) {
        alert(e.response?.data?.message); // Добавлена обработка ошибки
    }
}

// Room
export const createRoom = async (room) => {
    try {
        const {data} = await $authHost.post('api/room', room)
        return data
    } catch (e) {
        alert(e.response?.data?.message); // Добавлена обработка ошибки
    }
}
export const fetchRoom = async () => {
    try {
        const {data} = await $host.get('api/room')
        return data
    } catch (e) {
        alert(e.response?.data?.message); // Добавлена обработка ошибки
    }
}

// Repair
export const createRepair = async (repair) => {
    try {
        const {data} = await $authHost.post('api/repair', repair)
        return data
    } catch (e) {
        alert(e.response?.data?.message); // Добавлена обработка ошибки
    }
}
export const fetchRepair = async () => {
    try {
        const {data} = await $host.get('api/repair')
        return data
    } catch (e) {
        alert(e.response?.data?.message); // Добавлена обработка ошибки
    }
}

// Heating
export const createHeating = async (heating) => {
    try {
        const {data} = await $authHost.post('api/heating', heating)
        return data
    } catch (e) {
        alert(e.response?.data?.message); // Добавлена обработка ошибки
    }
}
export const fetchHeating = async () => {
    try {
        const {data} = await $host.get('api/heating')
        return data
    } catch (e) {
        alert(e.response?.data?.message); // Добавлена обработка ошибки
    }
}

// Building
export const createBuilding = async (building) => {
    try {
        const {data} = await $authHost.post('api/building', building)
        return data
    } catch (e) {
        alert(e.response?.data?.message); // Добавлена обработка ошибки
    }
}
export const fetchBuilding = async () => {
    try {
        const {data} = await $host.get('api/building')
        return data
    } catch (e) {
        alert(e.response?.data?.message); // Добавлена обработка ошибки
    }
}